import { LoaderFunctionArgs } from 'react-router';

import { groupInnerRoutes } from '@/backoffice/app/routes/groups/group-inner-routes';
import { TBackofficeGroupLoaderItem } from '@/backoffice/features/groups/groups.types';
import { LastGroupRedirect } from '@/shared/features/groups/components/last-group-redirect/last-group-redirect';
import { NoGroupSelected } from '@/shared/features/groups/components/no-group-selected/no-group-selected';
import {
  getGroupAncestorCrumb,
  getGroupCrumbLabel,
} from '@/shared/features/groups/utils/group-hierarchy/group-crumbs';
import { TCustomRouteObject } from '@/shared/types/router.types';

export const groupsRoutes: TCustomRouteObject = {
  path: '/groups',
  lazy: async () => {
    const { BackofficeGroupsListRoute } = await import('./groups');
    return { Component: BackofficeGroupsListRoute };
  },
  loader: async () => {
    const { backofficeResourceGroupsLoader } = await import('./groups');
    return backofficeResourceGroupsLoader();
  },
  handle: {
    crumb: {
      label: 'groups',
      localized: true,
    },
    permission: { action: 'backofficeGroup:readGroup' },
    suppressNavigationLoader: true,
  },
  children: [
    {
      index: true,
      Component: () => <LastGroupRedirect fallback={<NoGroupSelected />} />,
    },
    {
      path: ':groupId',
      lazy: async () => {
        const { BackofficeGroupRoute } = await import('./groups');
        return { Component: BackofficeGroupRoute };
      },
      loader: async (args: LoaderFunctionArgs) => {
        const { backofficeResourceGroupLoader } = await import('./groups');
        return backofficeResourceGroupLoader(args);
      },
      shouldRevalidate: () => true,
      handle: {
        crumb: {
          label: (data: TBackofficeGroupLoaderItem | string) =>
            getGroupCrumbLabel(data),
          ancestor: (data: TBackofficeGroupLoaderItem | string) =>
            getGroupAncestorCrumb(data),
        },
      },
      children: groupInnerRoutes,
    },
  ],
};
